import { render, staticRenderFns } from "./MyDeviceList.vue?vue&type=template&id=15dbbb36&scoped=true"
import script from "./MyDeviceList.vue?vue&type=script&lang=js"
export * from "./MyDeviceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dbbb36",
  null
  
)

export default component.exports